/*
 * Free gift auto-add for todaysfans.com (replaces the BOGOS app).
 *
 * - When any cart line belongs to a product tagged `sale_enable`, the ARRIA duster
 *   is added once with the line property `_free_gift`.
 * - When no qualifying product remains, the auto-added duster is removed.
 * - The auto-added line is kept at quantity 1.
 * - The $0 price itself comes from Shopify's automatic Buy X Get Y discount, so
 *   checkout enforces the rule even if this script is bypassed.
 *
 * Config is injected by snippets/free-gift.liquid as window.tfFreeGift.
 */
(function () {
  var cfg = window.tfFreeGift;
  if (!cfg || !cfg.variantId) return;

  var TAG_CACHE_KEY = 'tfFreeGiftTags';
  var FAIL_KEY = 'tfFreeGiftFailed';
  var busy = false;
  var pending = false;
  var waiters = [];

  function storageGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function storageSet(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }

  var tagCache = {};
  try { tagCache = JSON.parse(storageGet(TAG_CACHE_KEY) || '{}') || {}; } catch (e) { tagCache = {}; }

  function productQualifies(handle) {
    if (Object.prototype.hasOwnProperty.call(tagCache, handle)) {
      return Promise.resolve(tagCache[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        var tags = (product && product.tags) || [];
        var ok = tags.indexOf(cfg.qualifyingTag) !== -1;
        tagCache[handle] = ok;
        storageSet(TAG_CACHE_KEY, JSON.stringify(tagCache));
        return ok;
      })
      .catch(function () { return false; });
  }

  function isGiftLine(item) { return Number(item.variant_id) === Number(cfg.variantId); }
  function isAutoGift(item) { return isGiftLine(item) && !!(item.properties && item.properties._free_gift); }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartPost(path, body) {
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { throw new Error('cart request failed: ' + r.status); }
      return r.json();
    });
  }

  function decide(cart) {
    var items = cart.items || [];
    var giftLines = items.filter(isGiftLine);
    var others = items.filter(function (i) { return !isGiftLine(i); });
    if (!others.length) {
      return Promise.resolve({ qualifies: false, giftLines: giftLines });
    }
    var handles = [];
    others.forEach(function (i) { if (i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle); });
    return Promise.all(handles.map(productQualifies)).then(function (results) {
      return { qualifies: results.some(Boolean), giftLines: giftLines };
    });
  }

  // Returns a promise resolving to true when the cart was changed.
  function apply(cart) {
    return decide(cart).then(function (d) {
      var autoLines = d.giftLines.filter(isAutoGift);

      if (!d.qualifies) {
        if (autoLines.length) {
          return cartPost('/cart/change.js', { id: autoLines[0].key, quantity: 0 }).then(function () { return true; });
        }
        return false;
      }

      if (!d.giftLines.length) {
        if (storageGet(FAIL_KEY)) return false;
        return cartPost('/cart/add.js', {
          items: [{ id: cfg.variantId, quantity: 1, properties: { _free_gift: cfg.label } }]
        }).then(function () { return true; })
          .catch(function () { storageSet(FAIL_KEY, '1'); return false; });
      }

      // Safety net: if the automatic discount did not zero the auto-added line
      // (discount paused/expired), take it out rather than charge for it.
      var unpaid = autoLines.filter(function (l) { return Number(l.final_line_price) > 0; });
      if (unpaid.length) {
        storageSet(FAIL_KEY, '1');
        return cartPost('/cart/change.js', { id: unpaid[0].key, quantity: 0 }).then(function () { return true; });
      }

      var extra = autoLines.filter(function (l) { return l.quantity > 1; });
      if (extra.length) {
        return cartPost('/cart/change.js', { id: extra[0].key, quantity: 1 }).then(function () { return true; });
      }
      return false;
    });
  }

  function render(cart) {
    if (document.getElementById('cart_form')) {
      window.location.reload();
      return;
    }
    if (typeof originalRefresh === 'function') originalRefresh(cart);
  }

  function finish() {
    busy = false;
    var w = waiters; waiters = [];
    w.forEach(function (fn) { fn(); });
    if (pending) { pending = false; sync(); }
  }

  // Public: sync(cart?) -> Promise that resolves when the cart is consistent.
  function sync(cart) {
    if (busy) {
      pending = true;
      return new Promise(function (resolve) { waiters.push(resolve); });
    }
    busy = true;
    var source = cart ? Promise.resolve(cart) : getCart();
    return source.then(apply).then(function (changed) {
      if (changed) return getCart().then(render);
    }).catch(function () {}).then(finish);
  }

  var originalRefresh = window.refreshCart;
  if (typeof originalRefresh === 'function') {
    window.refreshCart = function (cart) {
      originalRefresh.apply(this, arguments);
      sync(cart);
    };
  }

  cfg.sync = sync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
})();
